import { cva } from "class-variance-authority";

/**
 * NavigationTabs Trigger Variants
 *
 * V&A Waterfront Design System - Navigation Tabs
 * Figma: https://www.figma.com/design/CV2ePEn9S0SSZ7T3AAPqF4/V-A-Waterfront---Website---Foundation-Design-System?node-id=10525-24467
 *
 * Sizes (from Figma):
 * - sm: 32px height, px-3 (12px), py-2 (8px), gap-1 (4px), 14px text
 * - lg: 48px height, px-4 (16px), py-3 (12px), gap-2 (8px), 16px text
 *
 * States:
 * - Default: Text only, transparent background, text-primary
 * - Hover: Light background (open-water-50), text-primary
 * - Selected (data-[state=active]): Blue background (button-primary-background), white text
 * - Disabled: Grey text (text-disabled), no interaction
 */

export const navigationTabsTriggerVariants = cva(
  // Base styles
  [
    "inline-flex items-center justify-center whitespace-nowrap",
    "rounded-full transition-colors cursor-pointer",
    "focus:outline-none focus-visible:ring-2 focus-visible:ring-open-water-100 focus-visible:ring-offset-0",
    // Default state - transparent background, primary text
    "bg-transparent text-text-primary",
    // Hover state - light background
    "hover:bg-open-water-50",
    // Selected/Active state - blue background, reversed text
    "data-[state=active]:bg-button-primary-background data-[state=active]:text-white",
    "data-[state=active]:hover:bg-button-primary-background-hover",
    // Disabled state
    "disabled:text-text-disabled disabled:bg-transparent disabled:pointer-events-none disabled:cursor-not-allowed",
    "data-[disabled]:text-text-disabled data-[disabled]:bg-transparent data-[disabled]:pointer-events-none data-[disabled]:cursor-not-allowed",
  ],
  {
    variants: {
      size: {
        // Small - H32 (97×32 from Figma)
        sm: ["h-8 px-3 py-2 gap-1", "typography-component-xs-medium"],
        // Large - H48 (115×48 from Figma)
        lg: ["h-12 px-4 py-3 gap-2", "typography-component-sm-medium"],
      },
    },
    defaultVariants: {
      size: "sm",
    },
  },
);

/**
 * NavigationTabs List Variants
 */
export const navigationTabsListVariants = cva([
  "inline-flex items-center gap-1",
  "scrollbar-none",
]);
